// extracted by mini-css-extract-plugin
export default {"marker":"AdditionalLabelMarker_marker__EN7r+"};